import React, { Component } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import { BaseComponent } from "BaseComponent";
import TimezonePicker from "react-timezone";
import Button from "react-bootstrap-button-loader";
import moment from "moment-timezone";
import LocaleStrings from "Languages";

export default class TimeZoneSelect extends BaseComponent {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    // this.close = this.close.bind(this);
    this.onTimezoneChange = this.onTimezoneChange.bind(this);
    this.state = {
      showModal: false,
      selectedValue: props.defaultTimezone,
      selectedValue: true,
    };
  }
  open = () => {
    this.setState({ showModal: true });
  };

  close = () => {
    this.setState({ showModal: false });
    this.setState({ selectedValue: false });
  };

  onTimezoneChange = (timezone) => {
    this.setState({ selectedValue: timezone });
  };

  updateTimezone = () => {
    this.props.timezonecallback(this.state.selectedValue);
    this.close();
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.defaultTimezone !== this.props.defaultTimezone) {
      this.setState({ selectedValue: nextProps.defaultTimezone });
    }
  }

  render() {
    var curTimezone = moment().tz(this.props.defaultTimezone).format("Z z");

    return (
      <div className="timezone-link" style={{ display: "flex" }}>
        <div
          className="col-md-10 field-box-timezone"
          style={{ padding: 8, paddingLeft: 15, color: "#18203A" }}
        >
          <span
            style={{ fontSize: "14px" }}
          >{`${this.props.defaultTimezone} - (${curTimezone})`}</span>
        </div>
        <div className="col-md-2">
          <span>
            <Button
              className="btn btn-custom-blue btn-change"
              type="button"
              onClick={this.open}
              style={{marginLeft:"10px"}}
            >
              {LocaleStrings.button_change}
            </Button>
          </span>
        </div>
        <Modal
          className="modal-container"
          show={this.state.showModal === true ? true : false}
          onHide={this.close}
          animation={true}
          backdrop="static"
        >
          <Modal.Header>
            <div className="import-modal-title">
              {LocaleStrings.general_form_label_event_timezone_model_header}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.close()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <label className="col-sm-12">
                {
                  LocaleStrings.general_form_label_event_timezone_select_timezone
                }
              </label>
              <div className="col-sm-12 col-sm-offset-0">
                <TimezonePicker
                  defaultValue={this.props.defaultTimezone}
                  onChange={this.onTimezoneChange}
                  inputProps={{
                    placeholder:
                      this.props.defaultTimezone + `(${curTimezone})`,
                    name: "timezone",
                  }}
                  value={this.state.selectedValue}
                  className="timezonepicker w-100"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={this.close}
              className="btn btn-custom-white"
              type="button"
            >
              {LocaleStrings.button_close}
            </button>
            <Button
              className="btn btn-custom-blue ml-10"
              onClick={this.updateTimezone}
            >
              {LocaleStrings.button_update}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
